import axios, { AxiosInstance } from 'axios'
import { ConfigApiResponseData, EnvironmentVariables, getConfigEnvironmentVariables } from '@/actions/config'
import { wrapNodeRequest } from '@/helpers/api/wrapNodeRequest'

const createApiClient = (): AxiosInstance => {
    const isServer = typeof window === 'undefined'
    let envVariables: EnvironmentVariables | undefined = isServer ? getConfigEnvironmentVariables() : undefined

    const api = axios.create({
        baseURL: undefined,
        withCredentials: true,
    })

    api.interceptors.request.use(
        async (config) => {
            if (!envVariables) {
                envVariables = (await wrapNodeRequest<ConfigApiResponseData>('/api/config', 'GET')).envVariables
            }
            return {
                ...config,
                baseURL: (typeof window === 'undefined' ? process.env.GATEWAY_INTERNAL_URL : undefined) ?? envVariables?.NEXT_PUBLIC_API_GATEWAY_BASEURL,
            }
        },
        (error) => Promise.reject(error),
    )

    api.interceptors.response.use(
        (response) => response,
        async (error) => {
            if (error?.response?.status !== 401) {
                return Promise.reject(error)
            }
        },
    )

    return api
}

const api = createApiClient()

export const get: AxiosInstance['get'] = api.get
export const post: AxiosInstance['post'] = api.post
export const put: AxiosInstance['put'] = api.put
export const destroy: AxiosInstance['delete'] = api.delete

export default api
